module.exports = __webpack_public_path__ + "img/categ-icon.e25e6312.png";